import { useEffect, useState } from "react";
import { useGetAdminRoleListQuery } from "../../reactQueries/commonRQHooks";

export const useGetAdminRoleGrouping = () => {

    const {
        isError: isErrorOnAdminRoleList,
        isFetching: isFetchingOnAdminRoleList,
        isSuccess: isSuccessOnAdminRoleList,
        data: adminRoleList,
        error: errorOnAdminRoleList,
    } = useGetAdminRoleListQuery();

    let enterpriseAdminRolesGrp = []
    let candidatePortalRolesGrp = []
    let clientPortalRolesGrp = []

    if (!!isSuccessOnAdminRoleList && !!adminRoleList) {
        adminRoleList.forEach((item) => {
            if (item?.groupName === "G1") {
                enterpriseAdminRolesGrp.push(item)
            } else if (item?.groupName === "G2") {
                candidatePortalRolesGrp.push(item)
            } else if (item?.groupName === "G3") {
                clientPortalRolesGrp.push(item)
            }
        })
    }

    return {
        enterpriseAdminRolesGrp,
        candidatePortalRolesGrp,
        clientPortalRolesGrp,
    }
}